export enum RefusRDVEnum {
	DEJA_RDV = 'dejaRDV',
	MEME_RESIDENCE = 'memeResidence'
}